import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import EmailCapture from "./EmailCapture";
import { X } from "lucide-react";

const StickySubscribeBanner = ({ darkMode }) => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const dm = darkMode;
  useEffect(() => { const t = setTimeout(() => setVisible(true), 4500); return () => clearTimeout(t); }, []);
  if (!visible || dismissed) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 px-4 pb-4 pointer-events-none">
      <div data-testid="sticky-subscribe-banner" className={`max-w-2xl mx-auto rounded-2xl p-5 pointer-events-auto ${dm ? "bg-[#1a2122]/96 backdrop-blur-md" : "bg-white/96 backdrop-blur-md"}`}
        style={{ boxShadow: "0 0 0 1px rgba(0,104,116,0.12), 0 -8px 40px rgba(0,104,116,0.1)" }}>
        <div className="flex items-start gap-4">
          <div className="flex-1">
            <p className={`text-sm font-semibold mb-0.5 ${dm ? "text-slate-100" : "text-[#191c1d]"}`}>Get the weekly AI Tourism digest</p>
            <p className={`category-tag mb-3 ${dm ? "text-slate-500" : "text-[#6b7a7d]"}`}>Curated by Mirko Lalli · Free · No spam ever</p>
            <EmailCapture darkMode={dm} />
            <p className={`category-tag mt-2 ${dm ? "text-slate-600" : "text-[#bac9cc]"}`}>
              Already have an account?{" "}
              <button onClick={() => navigate("/auth")} className={`${dm ? "text-cyan-400" : "text-[#006874]"}`}>Log in →</button>
            </p>
          </div>
          <button onClick={() => setDismissed(true)} data-testid="dismiss-banner-btn"
            aria-label="Close subscription banner"
            className={`flex-shrink-0 p-1.5 rounded-lg transition-colors ${dm ? "text-slate-600 hover:text-slate-400" : "text-[#bac9cc] hover:text-[#6b7a7d]"}`}>
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default StickySubscribeBanner;
